<script setup >
    import * as icons from "lucide-vue-next"
    import { computed } from "vue"

    const props = defineProps({
    name: {
        type: String,
        required: true,
    },
    size: {
        type: [Number, String],
        default: 15,
    },
    strokeWidth: {
        type: [Number, String],
        default: 2,
    },
    color: {
        type: String,
        default: "currentColor",
    },
    className: {
        type: String,
        default: "",
    },
    });

    // Pick the icon component by name
    const IconComponent = computed(() => icons[props.name]);
</script>

<template>
  <component
    :is="IconComponent"
    v-bind="{ size, color, 'stroke-width': strokeWidth }"
    :class="className"
    v-if="IconComponent"
  />

  <!-- fallback if icon not found -->
  <span v-else class="text-danger text-xs">Icon not found: {{ name }}</span>
</template>